<template>
  <section class="investment-data"
           data-ivp-class="--animate">
    <div class="content">
      <div class="overlay">
      </div>
      <h3 class="uptitle">
        A GROWING OPPORTUNITY
      </h3>
      <h2 class="title">
        Now is the time for Cannabis Investments.
      </h2>
      <p class="description">
        Legal sales of cannabis in the U.S. grew 40% in 2021 to $25 billion, according to research from BofA Securities. The total U.S. economic impact from cannabis sales is expected to reach $160 billion in 2025.*
      </p>
      <ul class="data-points"
          data-ivp-class="--animate">
        <li class="data-item">
          <div class="icon">
            <svg viewBox="0 0 100 100" height="100" width="100">
              <circle cx="50" cy="50" r="40" stroke-width="5"
              class="bg" />
              <circle cx="50" cy="50" r="40" stroke-width="5"
              class="graph"
              style="stroke-dashoffset:930;"/>
            </svg>
            <img src="@/assets/investment-data/icon_graph.svg">
          </div>
          <div class="value">
            <b> $25 Billion </b><br>
            Legal sales of Cannabis in the U.S. in 2021.
          </div>
        </li>
        <li class="data-item">
          <div class="icon">
            <svg viewBox="0 0 100 100" height="100" width="100">
              <circle cx="50" cy="50" r="40" stroke-width="5"
              class="bg" />
              <circle cx="50" cy="50" r="40" stroke-width="5"
              class="graph"
              style="stroke-dashoffset:760;" />
            </svg>
            <img src="@/assets/investment-data/icon_money.svg">
          </div>
          <div class="value">
            <b> $160 Billion </b><br>
            Expected Total Cannabis Economic impact in 2025*
          </div>
        </li>
      </ul>
      <a href="https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view" class="button"
        target="_blank"
         data-ivp-class="--animate">
        Invest Now
      </a>
    </div>
    <div class="illustration">
      <div class="image"
          style="background-image:url(https://cannabislocal.wpengine.com/wp-content/uploads/2022/02/Alien-Fire-Fruit-Nug-2-1-scaled.jpg)">
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/InvestmentData.scss';
</style>


<script>

export default {
  name: 'InvestmentData',
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
  },
  mounted() {
  },
};
</script>